import type {AxiosRequestConfig} from 'axios';

import {spotheroPost} from 'api';
import type {ApiResponse} from 'api/api.types';
import {camelizeKeys, convertKeysToSnakeCase} from 'utils/format-strings';
import {sendSentryException} from 'utils/error-handling';
import {
    GetEventFacilityBreakdownRequest,
    RawGetEventFacilityBreakdownRequest,
    RawGetEventFacilityBreakdownResponse,
} from './events.types';

/**
 * Formats the facility breakdown request body for the monolith API.
 */
const formatFacilityBreakdownRequest = (
    params: GetEventFacilityBreakdownRequest
): RawGetEventFacilityBreakdownRequest => {
    return convertKeysToSnakeCase(params);
};

/**
 * Formats the facility breakdown response results.
 */
const formatFacilityBreakdownResponse = (
    response: ApiResponse<RawGetEventFacilityBreakdownResponse[]>['data']
) => {
    const formattedResults = camelizeKeys(response);

    return formattedResults;
};

/**
 * Gets facility breakdown data for one or more events/facilities.
 * @returns A promise resolving to results + pagination meta.
 */
const postFacilityBreakdown = async (
    eventIds: number[],
    facilityIds: number[],
    offset: number,
    searchText: string,
    config: AxiosRequestConfig = {}
) => {
    try {
        const formattedRequest = formatFacilityBreakdownRequest({
            eventIds,
            facilityIds,
            offset,
            ...(searchText ? {searchText} : {}),
        });

        const response = await spotheroPost<
            RawGetEventFacilityBreakdownResponse[]
        >('events/facility-breakdown/', formattedRequest, config, false);

        const results = formatFacilityBreakdownResponse(response.data);

        return results;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default postFacilityBreakdown;
